import { environment } from '../../environments/environment';

export const WAREHOUSE_QUICK_SWITCH_ORDER = ['101', '110', '130', '300', '400', '450'] as const;

export type WarehouseQuickSwitchId = (typeof WAREHOUSE_QUICK_SWITCH_ORDER)[number];

export interface WarehouseContextRow {
    division: string;
    facility: string;
    warehouse: string;
}

/** Division / facility / warehouse for each selectable warehouse preset. Company is injected per environment via getWarehouseQuickSwitchPresets. */
export const WAREHOUSE_CONTEXT_ROWS: Record<WarehouseQuickSwitchId, WarehouseContextRow> = {
    '101': { division: '100', facility: '100', warehouse: '101' },
    '110': { division: '100', facility: '100', warehouse: '110' },
    '130': { division: '100', facility: '100', warehouse: '130' },
    '300': { division: '300', facility: '300', warehouse: '300' },
    '400': { division: '400', facility: '400', warehouse: '400' },
    '450': { division: '400', facility: '400', warehouse: '450' }
};

export interface WarehouseQuickSwitchPreset {
    id: WarehouseQuickSwitchId;
    /** Same as warehouse code; shown on buttons */
    label: string;
    company: string;
    division: string;
    facility: string;
    warehouse: string;
}

/**
 * Builds preset list for the current UI. Production omits warehouse 450; dev keeps all six.
 * @param company 080 when production, 782 typically for dev
 */
export function getWarehouseQuickSwitchPresets(company: string): WarehouseQuickSwitchPreset[] {
    let ids = [...WAREHOUSE_QUICK_SWITCH_ORDER];
    if (environment.production) {
        ids = ids.filter((id) => id !== '450');
    }
    return ids.map((id) => {
        const row = WAREHOUSE_CONTEXT_ROWS[id];
        return {
            id,
            label: id,
            company,
            ...row
        };
    });
}
